/*
 * <lab-rating-stars>: al clic sul link scorre alla sezione indicata da data-scroll-target.
 *
 * Il valore e la CHIAVE della sezione nel template (es. 55bd100e-3bbd-426c-a5cf-eed7b2a3706f):
 * l'id reale della sezione (shopify-section-template--<n>__<chiave>) cambia da tema a tema, quindi
 * si risolve a runtime. Si accetta anche un selettore "#id".
 *
 * scrollIntoView va bene qualunque sia il contenitore che scorre (da 990px in su Horizon scorre
 * .page-wrapper e non window).
 */
class LabRatingStars extends HTMLElement {
  connectedCallback() {
    this.addEventListener('click', this.#onClick);
  }

  disconnectedCallback() {
    this.removeEventListener('click', this.#onClick);
  }

  /** @returns {Element | null} */
  #target() {
    const key = (this.dataset.scrollTarget || '').trim();
    if (!key) return null;

    if (key.startsWith('#')) {
      try {
        return document.querySelector(key);
      } catch {
        return null;
      }
    }

    return (
      document.querySelector(`[id^="shopify-section-"][id$="__${CSS.escape(key)}"]`) ||
      document.getElementById(`shopify-section-${key}`)
    );
  }

  /** @param {MouseEvent} event */
  #onClick = (event) => {
    if (!(event.target instanceof Element)) return;
    if (!event.target.closest('[data-lab-rating-link]')) return;

    // Il link ha href="#": lo blocchiamo sempre, anche se la sezione non si trova,
    // per non far saltare la pagina in cima.
    event.preventDefault();

    const target = this.#target();
    if (!target) return;

    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    target.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'start' });
  };
}

if (!customElements.get('lab-rating-stars')) {
  customElements.define('lab-rating-stars', LabRatingStars);
}
